module.exports = __webpack_public_path__ + "img/altar_of_greed_small.2b91370b.png";